var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDealer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#636a6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.529 70.7c.738-.16 9.709-2.2 16.217 4.24a17.539 17.539 0 0 1 4.967 10.852v13.708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.833 70.7c-.739-.16-9.2-2.2-15.7 4.24a17.542 17.542 0 0 0 -4.973 10.851v13.709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.3 56.57c3.675 4.091 8.514 6.952 13.9 6.952 5.236 0 10.249-3.247 13.9-7.227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.405 34.373c6.181.225.344 16.852-4.3 21.922v11.65c9.262-12.745 27.34-68.711-13.905-67.423-43.125 1.344-26 57.4-13.9 67.423v-11.375s-3.1-3.028-5.983-10.322c-4.3-10.886-7.675-23.943.708-21.263 4.005 1.279 10.775 3.315 16.375 1.378s13.275-8.532 16.7-7.434-.52 15.271 4.305 15.444z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m64.1 67.945 10.429 2.755-19.3 16.787c-1.694-3.355-3.326-6.711-5.02-10.066 4.755-3.085 9.14-6.393 13.891-9.476z",
    stroke: "#ff5a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.3 67.945-10.467 2.755 19.3 16.787 5.079-10.067c-4.753-3.084-9.156-6.392-13.912-9.475z",
    stroke: "#ff5a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.212 97.795 5.02-10.309-5.02-10.066-5.083 10.066z",
    stroke: "#ff5a00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealer);
export default __webpack_public_path__ + "static/media/dealer.930290474fac774ab60b7bb31b7f62ec.svg";
export { ForwardRef as ReactComponent };